<div [ngClass]="componentClass" [ngStyle]="componentStyle">

  <se-icon
    *ngIf="icon"
    class="se-avatar__icon se-icon--no-margin"
    [ngClass]="ballIconClass"
    [ngStyle]="{color: iconColor}"
    name="{{ icon }}">
  </se-icon>

</div>